import { render, staticRenderFns } from "./AddNewDishDialog.vue?vue&type=template&id=568e0b87"
import script from "./AddNewDishDialog.vue?vue&type=script&lang=js"
export * from "./AddNewDishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports